import { axiosApi } from "../../../../../../../api/dbAxios";

export const deleteFavoriteItem = async (code: string, case_no: string) => {
  try {
    const response = await axiosApi.delete("/favorite/", {
      data: { code, case_no },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting favorite item:", error);
    return {};
  }
};
